import { useSelector } from 'react-redux';


const useDid = () => {
	const staticData = useSelector(state => state.staticData.data)

	function  toFindDid(orgId) {
		const org = staticData?.orgs?.find(org => org.orgId === orgId)
		return org?.didAddress.replace('did:ethr:', '')
	}

	function toFindOrg(did) {
		const org = staticData?.orgs?.find(org => org.didAddress.replace('did:ethr:', '') === did)
		return org
	}

	function toFindOrgName(did) {
		return toFindOrg(did)?.name
	}

	function toFindOrgId(did) {
		return toFindOrg(did)?.orgId
	}

	return {
		toFindDid,
		toFindOrg,
		toFindOrgId,
		toFindOrgName
	}
}

export default useDid
